<template>
  <div class="item-view">
    <div class="row">
      <div class="col-sm-6" v-if="hasPassages">
        <item-passage
          :locked="locked"
          v-for="(passage, index) in item.passages"
          :key="index"
          :passage="passage"/>
      </div>

      <div :class="colClassForItem">
        <div
          v-for="(p, index) in item.parts"
          :key="index"
          class="item-part"
          :class="{'item-part--bordered': index === 0}">
          <h4 class="part-heading" v-if="item.parts.length > 1">Part {{ index + 1 }}</h4>
          <div class="item-prompt">
            <wiki-text
              :text="p.prompt"
              :resources="!locked && resourceMap || {}"
              :locked="locked" />
          </div>
        </div>

        <div class="item-response-container">
          <item-heading :level="level">
            Model Student Response
          </item-heading>
          <collapse v-model="showAnswers">
            <div class="item-response__content">
              <div
                class="item-response"
                v-for="(p, index) in item.parts"
                :key="index">

                <h4 class="part-heading" v-if="item.parts.length > 1">Part {{ index + 1 }}</h4>
                <div>
                  <wiki-text
                    :text="p.response"
                    :resources="resourceMap"
                    :locked="locked" />
                </div>
              </div>
            </div>
          </collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WikiText from '@/components/WikiText'
import ItemPassage from '@/components/goals/ItemPassage'
import ItemHeading from '@/components/goals/ItemHeading'
export default {
  name: 'ItemView',
  components: {
    ItemPassage,
    WikiText,
    ItemHeading
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    level: {
      type: String,
      required: true
    },
    locked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showAnswers: true
    }
  },
  computed: {
    resourceMap() {
      let resourceMap = {}
      this.item.resources.forEach(resource => {
        resourceMap[resource.uuid] = resource
      })
      return resourceMap
    },
    hasPassages() {
      return this.item && this.item.passages.length > 0
    },
    colClassForItem() {
      if (this.hasPassages) {
        return 'col-sm-6'
      }
      return 'col-sm-12'
    }
  }
}
</script>

<style scoped lang="less">
.item-view {
  .part-heading {
    margin-top: 24px;
  }
  .item-part {
    margin-bottom: 24px;
    .item-prompt {
    }
  }

  .item-response-container {
    margin-top: 36px;

    .item-response {
    }
  }
}
</style>
